import { ArrowUpRightIcon, MegaphoneIcon } from 'lucide-react';

import { Card } from '@/components/ui/card';

const SBOM_ESCROW_URL =
  'https://codekeeper.co/solutions/cra-sbom-escrow?utm_campaign=43215271-app%20concept%20test&utm_source=codekeeper_app&utm_medium=app%20banner%20ad';

const ComingSoonCard = () => (
  <Card className="relative flex flex-col gap-6 overflow-hidden bg-[linear-gradient(158deg,#0C3A47_0%,var(--color-secondary-foreground)_62%,var(--color-foreground)_100%)] p-5">
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -top-15 -right-10 size-55 bg-[radial-gradient(circle,color-mix(in_srgb,var(--color-mint)_42%,transparent)_0%,transparent_70%)]"
    />
    <div className="relative flex items-center gap-1.5">
      <span className="flex size-8 shrink-0 items-center justify-center rounded-lg border border-white/15 bg-white/10">
        <MegaphoneIcon className="size-4.5 text-teal-200" />
      </span>
      <span className="grow text-sm font-bold text-white/60">Coming soon</span>
      <a
        href={SBOM_ESCROW_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 text-xs font-bold text-teal-200 hover:underline"
      >
        Learn more
        <ArrowUpRightIcon aria-hidden="true" className="size-3.5" />
      </a>
    </div>
    <div className="relative space-y-2">
      <h3 className="text-lg font-extrabold text-white">SBOM escrow</h3>
      <p className="text-sm leading-relaxed text-white/75">
        Generate your software bill of materials and store it with the rest of your deposit.
      </p>
    </div>
  </Card>
);

export default ComingSoonCard;
